import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { headerPadding } from '@helpers/header';
import { Device, from, until } from '@helpers/media';
import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import BreadcrumbStyles from '@stories/Components/Breadcrumb/Breadcrumb.styles';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { ReactComponent as SvgMirrorOuter } from '@img/masks/mirror-outer.svg';
import { ReactComponent as SvgMirrorPortraitOuter } from '@img/masks/mirror-portrait-outer.svg';
import { ReactComponent as SvgFrameOuter } from '@img/masks/frame-outer.svg';
import { ReactComponent as SvgCurtainsOuter } from '@img/masks/curtains-outer.svg';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.white};
  --iconFg: ${brand.sage.sageDark};
  --iconBg: ${brand.white};
  --headingColor: ${brand.sage.sageDark};
  --textColor: ${brand.black};

  ${headerPadding}

  ${BreadcrumbStyles.Container} {
    position: absolute;
    transform: translateY(-30px);
  }

  position: relative;
  background: var(--bgColor);
  color: var(--textColor);
  padding-top: calc(50px + ${cssVar('headerHeight')});
  padding-bottom: 0;

  &[data-bg-color='sage1'] {
    --bgColor: ${brand.sage.sageDark};
    --headingColor: ${brand.white};
    --textColor: ${brand.white};

    &[data-theme='${1 /* HomeStepper */}'] {
      --headingColor: ${brand.homeStepper.white};
      --textColor: ${brand.homeStepper.white};
    }
  }

  &[data-bg-color='sage3'] {
    --bgColor: ${brand.sage.sageLight};
    --headingColor: ${brand.white};
    --textColor: ${brand.white};

    &[data-theme='${1 /* HomeStepper */}'] {
      --headingColor: ${brand.sage.sageDark};
      --textColor: ${brand.sage.sageDark};
    }
  }

  &[data-bg-color='plum3'] {
    --bgColor: ${brand.plum.plumLight};

    &[data-theme='${1 /* HomeStepper */}'] {
      --headingColor: ${brand.plum.plumDark};
      --textColor: ${brand.plum.plumDark};
    }
  }

  &[data-bg-color='toast1'] {
    // --bgColor: ${brand.toast.toastLight};
  }

  &[data-bg-color='toast2'] {
    --bgColor: ${brand.toast.toastMedium};

    &[data-theme='${1 /* HomeStepper */}'] {
      --headingColor: ${brand.toast.toastBurnt};
      --textColor: ${brand.toast.toastBurnt};
    }
  }

  &[data-bg-color='sunshine3'] {
    --bgColor: ${brand.sunshine.sunshineLight};
  }

  &[data-bg-color='grey'] {
    --bgColor: ${brand.grey.greyLight};

    &[data-theme='${1 /* HomeStepper */}'] {
      --headingColor: ${brand.sage.sageDark};
      --textColor: ${brand.homeStepper.black};
    }
  }

  &[data-layout='text-only'] {
    padding-top: calc(70px + ${cssVar('headerHeight')});
    padding-bottom: 35px;

    @media ${until(Device.Tablet)} {
      padding-top: calc(40px + ${cssVar('headerHeight')});
      padding-bottom: 45px;
    }

    ${BreadcrumbStyles.Container} {
      transform: translateY(-35px);
    }
  }

  &[data-overhang='false'] {
    padding-bottom: 30px;

    @media ${from(Device.Tablet)} {
      padding-bottom: 100px;
    }

    @media ${from(Device.Desktop)} {
      padding-bottom: 190px;
    }
  }

  @media ${from(Device.Desktop)} {
    padding-top: calc(85px + ${cssVar('headerHeight')});

    ${BreadcrumbStyles.Container} {
      transform: translateY(-35px);
    }

    &[data-layout='text-only'] {
      padding-top: calc(125px + ${cssVar('headerHeight')});

      ${BreadcrumbStyles.Container} {
        transform: translateY(-90px);
      }
    }
  }

  &[data-theme='${1 /* HomeStepper */}'] {
    ${() => Title} {
      ${fonts.matter.medium};

      @media ${from(Device.TabletLarge)} {
        font-size: 60px;
        line-height: 60px;
      }
    }

    > * {
      ${fonts.matter.regular};
    }
  }
`;
const BreadcrumbHolder = styled(Breadcrumb) `
  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const Inner = styled.div `
  display: grid;
  gap: 40px;
  grid-template-columns: repeat(12, 1fr);

  @media ${until(Device.TabletLarge)} {
    gap: 28px 10px;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  z-index: 2;
  margin-bottom: -65px;
  align-self: center;
  position: relative;

  [data-layout='text-only'] & {
    display: none;
    margin-bottom: 0;
    align-self: flex-start;
  }

  [data-overhang='false'] & {
    margin-bottom: 0;
  }

  @media ${until(Device.Tablet)} {
    grid-row: 2;
    grid-column: 3 / span 8;

    [data-mask='mirror'] & {
      grid-column: 1 / span 12;
    }
  }

  @media ${from(Device.Tablet)} {
    grid-row: 1;
    transform: translateY(80px);
    margin-bottom: 0;

    [data-overhang='false'] & {
      transform: translateY(0);
    }

    [data-layout='image-left'] & {
      grid-column: 1 / span 6;
    }

    [data-layout='image-right'] & {
      grid-column: -7 / span 6;
    }
  }
`;
const Image = styled.img `
  display: block;
  object-fit: cover;
  object-position: center;
  width: 100%;
  clip-path: url(#mirror_svg__mask);

  max-height: 700px;

  [data-cropped-image='true'] & {
    height: auto;
  }

  [data-cropped-image='false'] & {
    object-fit: contain;
    width: auto;
    margin: auto;
  }

  @media ${until(Device.Tablet)} {
    max-height: 400px;
  }

  @media ${until(Device.MobileLarge)} {
    max-height: 260px;
  }
`;
const LottieWrapper = styled.div `
  position: relative;
  grid-row: 1;
  z-index: 2;

  [data-layout='text-only'] & {
    display: none;
  }

  @media ${until(Device.Tablet)} {
    grid-row: 1;
    grid-column: 1 / span 12;
    justify-self: center;
    max-width: 320px;
  }

  @media ${from(Device.Tablet)} {
    [data-layout='image-left'] & {
      grid-column: 1 / span 6;
    }

    [data-layout='image-right'] & {
      grid-column: -7 / span 6;
    }
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  grid-row: 1;
  max-width: 560px;
  margin-top: 150px;
  z-index: 2;

  [data-layout='text-only'] & {
    margin-top: 0;
  }

  @media ${until(Device.Tablet)} {
    grid-row: 1;
    grid-column: 1 / span 12;
    margin-top: 0;

    [data-layout='text-only'] & {
      grid-row: 1;
    }
  }

  @media ${from(Device.Tablet)} {
    [data-layout='text-only'] & {
      grid-column: 1 / span 12;
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      max-width: 100vw;
    }

    [data-layout='image-left'] & {
      grid-column: -7 / span 5;
    }

    [data-layout='image-right'] & {
      grid-column: 1 / span 5;
    }
  }
`;
const Title = styled.h1 `
  ${HeadingStyles.H1Styles}
  color: var(--headingColor);
  margin: 0 0 16px;

  [data-layout='text-only'] & {
    margin: 0 0 36px;
  }

  @media ${from(Device.Tablet)} {
    margin: 0 0 32px;

    [data-layout='text-only'] & {
      grid-column: 1 / span 5;
    }
  }
`;
const Content = styled.div `
  color: var(--textColor);
  @media ${from(Device.Tablet)} {
    margin: 0 0 32px;

    [data-layout='text-only'] & {
      grid-column: -7 / span 5;
    }
  }

  p {
    ${fonts.matter.regular};
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 16px;

    [data-layout='text-only'] & {
      font-size: 20px;
      line-height: 28px;
    }

    [data-theme='${1 /* HomeStepper */}'] & {
      ${fonts.matter.medium};
      font-size: 30px;
    }
  }

  a {
    ${RichTextStyles.linkStyles}
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('bgColor', brand.sage.sageLight)};
  }

  @media ${from(Device.Tablet)} {
    [data-layout='text-only'] & {
      font-size: 20px;
      line-height: 28px;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    p {
      font-size: 22px;
      line-height: 32px;

      [data-layout='text-only'] & {
        font-size: 24px;
        line-height: 34px;
      }
    }
  }

  @media ${from(Device.Desktop)} {
    p {
      [data-layout='text-only'] & {
        font-size: 32px;
        line-height: 42px;
      }
    }
  }
`;
const CtaWrapper = styled.div `
  margin: 32px 0 0;

  @media ${from(Device.Tablet)} {
    margin: 0 0 32px;

    [data-layout='text-only'] & {
      grid-column: -7 / span 5;
    }
  }
`;
const MirrorOuter = styled(SvgMirrorOuter) `
  position: absolute;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: ${brand.sage.sageDark};
`;
const MirrorPortraitOuter = styled(SvgMirrorPortraitOuter) `
  position: absolute;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: ${brand.sage.sageDark};
`;
const CurtainOuter = styled(SvgCurtainsOuter) `
  position: absolute;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  color: ${brand.sage.sageDark};
`;
const FrameOuter = styled(SvgFrameOuter) `
  position: absolute;
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: ${brand.sage.sageDark};
`;
const SplitContentStyles = {
    BreadcrumbHolder,
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    CurtainOuter,
    FrameOuter,
    Image,
    ImageWrapper,
    Inner,
    LottieWrapper,
    MirrorOuter,
    MirrorPortraitOuter,
    Title,
};
export default SplitContentStyles;
